module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-5.d219826d.jpg";